import { Application, Sprite } from "pixi.js";
import Scene from "./Scene";
import { ConfigParams } from "../GameConfig";
import JackpotHistory from "../components/JackpotHistory";
import { mockHistory } from "../dev/mockdata";
import { DEBUG, SIMULATION } from "../AppConfig";
import { JackpotHitData } from "../models/JackpotHitData";

type SceneHistoryProps = {
  app: Application;
  config: ConfigParams;
  name: string;
};

const STAGE = {
  width: 1920,
  height: 1080,
};

class SceneHistory extends Scene {
  videoLoaded: boolean = false;
  history: JackpotHistory;

  constructor({ app, config, name }: SceneHistoryProps) {
    super({
      app: app,
      name: name,
      bgVideoPath: config.history.video_path,
      bgImagePath: config.history.image_path,
    });

    this.history = new JackpotHistory();

    // if (DEBUG && SIMULATION) {
    //   // Debug
    //   for (const entry of mockHistory()) {
    //     this.history.add(entry);
    //   }

    //   this.history.update();
    // }

    this.contentContainer.addChild(this.history);
    this.history.zIndex = 3;
    // this.history.zIndex = this.topZ;

    // const plonk = Sprite.from(`_plonk_history`);
    // this.bgContainer.addChild(plonk);
    // plonk.zIndex = 1;

    const rays = Sprite.from(`jackpot-background-rays`);
    this.bgContainer.addChild(rays);
    rays.zIndex = 1;

    const historyBg = Sprite.from(`history-background`);
    historyBg.anchor.set(0.5, 0);
    historyBg.position.set(STAGE.width / 2, 0);
    const historyTitle = Sprite.from(`history-title`);
    historyTitle.anchor.set(0.5, 0.5);
    historyTitle.position.set(-5, 67);
    historyBg.addChild(historyTitle);

    for (let i = 0; i < 9; i++) {
      const divider = Sprite.from(`history-line`);
      divider.anchor.set(0.5, 0.5);
      divider.x = 0;
      divider.y = 212 + 93 * i;
      historyBg.addChild(divider);
    }

    this.contentContainer.addChild(historyBg);
    historyBg.zIndex = 2;
  }

  show(): void {
    super.show();
    this.history.show();
    this.history.hide(2000);
  }

  hide(): void {
    this.history.hideInstant();
    super.hide();
  }

  public updateHistory(history: JackpotHitData[]): void {
    for (const el of history) {
      this.history.add({
        location: el.location,
        time: el.timestamp,
        value: el.value,
      });
    }
    this.history.update();
  }
}

export default SceneHistory;
